import { render, staticRenderFns } from "./ButtonSubmitAnswer.vue?vue&type=template&id=b2ee36e0&"
import script from "./ButtonSubmitAnswer.vue?vue&type=script&lang=js&"
export * from "./ButtonSubmitAnswer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports